/** The admin readiness screen: the checks the store runs on itself. */
export default {
  'ready.title': 'System readiness',
  'ready.checked': 'Checked {when} · schema {schema}',
  'ready.schemaUnknown': 'unknown',
  'ready.rerunning': 'Re-running…',
  'ready.runAll': 'Run all checks',
  'ready.running': 'Running checks…',
  'ready.passing': 'Passing',
  'ready.warnings': 'Warnings',
  'ready.critical': 'Critical',
  'ready.suggested': 'Suggested:',
  'ready.testing': 'Testing…',
  'ready.test': 'Test now',
  'ready.ok': 'OK',
  'ready.warning': 'Warning',
  'ready.unknown': 'Not checked',
  'ready.passed': 'Passed in {ms}ms.',
  'ready.failed': 'Failed.',
  'ready.couldNotRun': 'The check could not run.',
} as const;
